import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  const cycle = [{
    text: 'Recibes dinero.',
    highlight: 'Recibes dinero'
  }, {
    text: 'Sientes alivio por un momento.',
    highlight: 'alivio'
  }, {
    text: 'Gastas, evitas o postergas decisiones.',
    highlight: 'Gastas, evitas o postergas'
  }, {
    text: 'Vuelve la culpa.',
    highlight: 'culpa'
  }, {
    text: 'Terminas otra vez en el mismo punto.',
    highlight: 'el mismo punto'
  }];
  return <section className="bg-primary py-10 md:py-16 px-4 md:px-12" data-id="element-243">
      <div className="max-w-4xl mx-auto" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-245">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-warm-white mb-4" data-id="element-246">
            ¿Te reconoces en este ciclo?
          </h2>
        </motion.div>

        {/* Cycle visual */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-lg mx-auto mb-12" data-id="element-247">
          <div className="relative" data-id="element-248">
            {cycle.map((step, idx) => <div key={idx} className="flex items-center gap-4 mb-1" data-id="element-249">
                {/* Step number circle */}
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-gold/10 border-2 border-gold flex items-center justify-center" data-id="element-250">
                  <span className="font-playfair font-bold text-gold text-lg md:text-xl" data-id="element-251">
                    {idx + 1}
                  </span>
                </div>
                {/* Step text */}
                <div className="flex-1 bg-secondary border border-card rounded-xl px-5 py-4" data-id="element-252">
                  <p className="font-inter text-base md:text-lg text-warm-white" data-id="element-253">
                    {step.text.split(step.highlight).map((part, i, arr) => <Fragment key={i} data-id="element-254">
                        {part}
                        {i < arr.length - 1 && <span className="text-gold font-semibold" data-id="element-255">
                            {step.highlight}
                          </span>}
                      </Fragment>)}
                  </p>
                </div>
                {/* Connector line */}
                {idx < cycle.length - 1 && <div className="absolute left-5 md:left-6 w-0.5 h-4 bg-gold/30" style={{
              top: `${(idx + 1) * 64 + 40}px`
            }} data-id="element-256" />}
              </div>)}
          </div>
        </motion.div>

        {/* Closing message */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-secondary border border-gold rounded-2xl p-6 md:p-10 text-center shadow-glow-gold max-w-2xl mx-auto" data-id="element-257">
          <p className="font-inter text-lg md:text-xl text-warm-white leading-relaxed mb-6" data-id="element-258">
            <span className="text-gold font-semibold" data-id="element-259">
              No lo haces porque quieras.
            </span>{' '}
            Es una{' '}
            <span className="text-gold font-semibold" data-id="element-260">reacción automática</span>{' '}
            de tu cuerpo.
          </p>
          <p className="font-inter text-base md:text-lg text-warm-muted leading-relaxed mb-6" data-id="element-261">
            Y cuando un patrón se repite por años, no basta con decir{' '}
            <span className="text-warm-white italic" data-id="element-262">"voy a cambiar"</span>.
          </p>
          <p className="font-inter text-base md:text-lg text-warm-muted leading-relaxed mb-6" data-id="element-263">
            Ese patrón{' '}
            <span className="text-warm-white font-semibold" data-id="element-264">
              no viene de tu mente
            </span>
            …
          </p>
          <div className="font-playfair font-bold text-2xl md:text-4xl text-gold" data-id="element-265">
            viene de tu sistema nervioso.
          </div>
        </motion.div>
      </div>
    </section>;
}